import styled from 'styled-components';
import { primary, secondary, lightGray, white, middleGray, darkGray, success, error, black } from 'styles/colorProvider';

export const Container = styled.div`
  background-color: ${white};
  width: 100%;
  margin-bottom: 100px;
  display: flex;
  align-items: top;
  justify-content: center;
`;

export const ContentArea = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: left;

  @media (max-width: 1000px) {
    align-items: center;
    width: 95%;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${primary};

  @media (max-width: 1000px) {
    text-align: center;
    margin-top: 10%;
  }
`;

export const PolicyInformationArea = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: -1.6%;

  .lastItem {
    height: 9%;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    width: 80%;
  }
`;

export const ItemPolicy = styled.div`
  border: 1px solid ${lightGray};
  border-radius: 20px;
  width: 41%;
  padding: 2.2% 3%;
  margin-top: 20px;

  @media (max-width: 1000px) {
    width: 100%;
    padding: 30px;
    margin-top: 30px;
  }
`;

export const Subtitle = styled.h2`
  color: ${primary};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  margin-bottom: 1%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.p`
  font-size: 14px;
  color: ${darkGray};
  margin: 0;
  margin-top: 2%;

  span {
    color: ${middleGray};
  }

  .link {
    cursor: pointer;
    text-decoration: underline;
    transition: all ease-in-out 0.3s;
    font-size: 12px;
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const LoadingArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 30px;
`;

export const InspectionImage = styled.div`
  background-image: ${(props) => `url(${props.image})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
  margin: 5px;
  transition: all ease-in-out 0.3s;
  cursor: pointer;
  &&:hover {
    opacity: 0.8;
  }
`;

export const PhotosArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Edit = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ModalButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  height: 30px;

  width: 100%;

  div {
    height: 100%;
    align-items: center;
    margin-left: 5px;
    justify-content: center;
    text-align: center;

    img {
      align-items: center;
      width: 20px;
      margin-top: 9px;
    }
  }
`;
export const inputStyle = {
  height: '40px',
  width: '100%',
  padding: '0 12px',
  fontSize: '14px',
  border: '1px solid #ccc',
  borderRadius: '4px',
};

export const DialogContent = styled.div`
  padding: ${(props) => props.padding || '20px'};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || '10px'};
  align-items: ${(props) => props.alignItems || 'stretch'};
  max-width: ${(props) => props.maxWidth || 'none'};
  margin: auto;
  border-radius: 12px;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap || '10px'};
  margin-top: ${(props) => props.marginTop || '0'};
  flex-wrap: ${(props) => props.flexWrap || 'nowrap'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'stretch'};
  width: ${(props) => props.width || 'auto'};
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || '10px'};
  margin-top: ${(props) => props.marginTop || '0'};
  align-items: ${(props) => props.alignItems || 'stretch'};
  width: ${(props) => props.width || '100%'};
`;

export const Label = styled.label`
  font-size: 14px;
  color: #666;
`;

export const PlateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  border: 4px solid ${black};
  border-radius: 12px;
  overflow: hidden;
  background-color: ${white};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 10px 0;
`;

export const PlateHeader = styled.div`
  background-color: ${secondary};
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  span {
    color: ${white};
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  &::before {
    content: '🇧🇷';
    position: absolute;
    left: 10px;
    font-size: 16px;
  }
`;

export const PlateBody = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
`;

export const InputPlate = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  font-family: 'Roboto Mono', monospace;
  font-size: 42px;
  font-weight: 800;
  color: ${black};
  text-align: center;
  letter-spacing: 4px;
  outline: none;
  text-transform: uppercase;

  &::placeholder {
    color: ${lightGray};
    font-size: 24px;
    letter-spacing: 1px;
  }
`;

export const ValueComparison = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin: 1.5rem 0;
  width: 100%;
`;

export const ValueCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 16px;
  background-color: ${(props) => (props.active ? '#f0f7ff' : '#f8f9fa')};
  border: 1px solid ${(props) => (props.active ? secondary : '#eee')};
  min-width: 140px;
  box-shadow: ${(props) => (props.active ? '0 4px 15px rgba(0, 0, 204, 0.1)' : 'none')};

  label {
    font-size: 12px;
    color: ${middleGray};
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${(props) => (props.variant === 'success' ? success : props.variant === 'error' ? error : primary)};
  }
`;

export const ErrorText = styled.span`
  color: red;
  font-size: 12px;
`;

export const EndorsementSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  margin-top: 1rem;
`;

export const EndorsementCard = styled.div`
  background: #fcfcfc;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 1.2rem;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${secondary};
    box-shadow: 0 4px 12px rgba(0, 0, 204, 0.05);
  }
`;

export const EndorsementHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 8px;

  svg {
    color: ${secondary};
    font-size: 20px;
  }

  h3 {
    font-size: 15px;
    font-weight: 700;
    color: ${primary};
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const EndorsementGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const EndorsementInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 11px;
    color: ${middleGray};
    text-transform: uppercase;
    font-weight: 600;
  }

  span {
    font-size: 13px;
    color: ${darkGray};
    font-weight: 500;
    
    &.empty {
      color: #ccc;
      font-style: italic;
    }
  }
`;

export const EndorsementDivider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 1.5rem 0;
  
  &::before, &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #eee;
  }
  
  span {
    padding: 0 15px;
    color: ${middleGray};
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

export const ProductItem = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  width: 90%;
  border: 1px solid ${(props) => (props.selected ? 'rgb(0 176 90)' : 'transparent')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const ProductItemButton = styled.div`
  display: flex;
  background-color: ${(props) => (props.isChecked ? 'rgb(0 176 90)' : 'white')};
  color: ${(props) => (props.isChecked ? 'white' : 'black')};
  width: auto;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 0 10px;
  margin-right: 15px;
  border-radius: 5px;
  text-transform: capitalize;
  font-size: 13px;
  border: 1px solid #e0e0e0;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background-color: ${(props) => (props.isChecked ? 'rgb(0, 140, 70)' : '#f0f0f0')};
  }
`;

export const CoveragesArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
`;
